import React, { FC } from 'react';
import { useRecoilValue } from 'recoil';
import { UserState, UserType, SessionState, SessionType } from '@dew21/ui';
import { Redirect } from 'react-router';

export const AuthGuard: FC = (props) => {
  const user = useRecoilValue<UserType>(UserState);
  const session = useRecoilValue<SessionType>(SessionState);

  return <>{(user?.current !== null && session?.current !== null && session?.current?.tokens?.accessToken?.length > 0) ? props.children :
    <Redirect to={'/login'}/>}</>;

};
